import React from 'react'
import PaymentDetailsContainer from '../../../../Components/Applications/ECommerce/PaymentDetails'

export default function PaymentDetails() {
    return (
        <div className='page-body'>
            <PaymentDetailsContainer />
        </div>
    )
}